<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="formulation-title" :field="fields?.title" tag="h2" />
      <div class="formulation-content">
        <AdaptiveImage
          class="formulation-content-image"
          :field="fields?.image"
          :isBackground="false"
          :lazy-load="false"
          :enableScrollDetection="false"
          :show="true"
        />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'Formulation',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'formulation'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.formulation {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;
    margin-top: 20px;

    &::-webkit-scrollbar {
      display: none;
    }

    &-image {
      width: 1135px;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      margin-top: 40px;

      &-image {
        width: 100%;
      }
    }
  }
}
</style>
